export default "__VITE_ASSET__aSp$McTa__"